import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import IncrementButton from '../../buttons/incrementButton/IncrementButton';
import NumberInputWithUnit from '../numberInputWithUnit/NumberInputWithUnit';
import style from './DualValueListInput.module.css';
import { cloneDeep } from 'lodash';
import Tag from '../tagInput/Tag';
import { colors } from '../../../../colorVars';

function DualValueListInput({
  symbol1,
  symbol2,
  onAddDelete,
  direction1,
  direction2,
  currentValues1,
  currentValues2,
  type1,
  type2,
  buttonColor,
  buttonBgColor,
}) {
  const [valueList, setValueList] = useState([]);
  const [inputVal1, setInputVal1] = useState('');
  const [inputVal2, setInputVal2] = useState('');
  const [error, setError] = useState(false);

  const addToList = () => {
    if (inputVal1 === '' || inputVal2 === '') {
      setError(true);
    } else {
      setError(false);
      onAddDelete([...valueList, [inputVal1, inputVal2]]);
      setValueList((prev) => [...prev, [inputVal1, inputVal2]]);
    }
  };

  const stringListToArray = (list) => {
    if (Array.isArray(list)) {
      return list;
    } else {
      if (!list?.length) return [];
      else return list.split(',');
    }
  };

  const removeFromList = (index) => {
    const copy = cloneDeep(valueList);
    if (copy.length === 1) {
      setValueList([]);
      onAddDelete([]);
    } else {
      copy.splice(index, 1);
      setValueList([...copy]);
      onAddDelete(copy);
    }
  };

  useEffect(() => {
    let values1;
    let values2;

    if (type1 === 'percentageArray') {
      if (typeof currentValues1 === 'string') {
        values1 = currentValues1.split(',').map((item) => {
          const percent = Number(item) * 100;
          return percent.toString();
        });
      } else {
        values1 = currentValues1.map((item) => {
          const percent = Number(item) * 100;
          return percent.toString();
        });
      }
    } else if (type1 === 'decimal') {
      values1 = stringListToArray(currentValues1).map((item) =>
        Number(item).toFixed(2).toString()
      );
    } else {
      values1 = stringListToArray(currentValues1);
    }
    if (type2 === 'percentageArray') {
      values2 = currentValues2.map((item) => {
        const percent = Number(item) * 100;
        return percent.toString();
      });
    } else if (type2 === 'decimal') {
      values2 = stringListToArray(currentValues2).map((item) =>
        Number(item).toFixed(2).toString()
      );
    } else {
      values2 = stringListToArray(currentValues2);
    }
    if (values1.length >= values2.length) {
      const arr = values1.map((value, index) => {
        if (values2[index]) return [value, values2[index]];
        else return [value, 'none'];
      });
      setValueList(arr);
    } else {
      const arr = values2.map((value, index) => {
        if (values1[index]) return [values1[index], value];
        else return ['none', value];
      });
      setValueList(arr);
    }
  }, [currentValues1, currentValues2]);

  return (
    <div className={style.container}>
      <div>
        {valueList.map((value, index) => {
          return (
            <Tag
              key={value + index + ''}
              closeHandler={(index) => {
                removeFromList(index);
              }}
              index={index}
            >
              {direction1 === 'left' &&
                direction2 === 'left' &&
                `${symbol1 + value[0]} | ${symbol2 + value[1]}`}
              {direction1 === 'right' &&
                direction2 === 'left' &&
                `${value[0] + symbol1} | ${symbol2 + value[1]}`}
              {direction1 === 'left' &&
                direction2 === 'right' &&
                `${symbol1 + value[0]} | ${value[1] + symbol2}`}
              {direction1 === 'right' &&
                direction2 === 'right' &&
                `${value[0] + symbol1} | ${value[1] + symbol2}`}
            </Tag>
          );
        })}
      </div>
      <p style={{ fontSize: '8px', color: 'red' }}>
        {error ? 'Missing field' : ''}
      </p>
      <div className={style.inputs}>
        <NumberInputWithUnit
          inputWidth="5em"
          value={inputVal1}
          setValue={setInputVal1}
          onBlur={() => {}}
          direction={direction1}
        >
          {symbol1}
        </NumberInputWithUnit>
        <span style={{ fontSize: '16px', margin: '0 3px' }}> | </span>
        <NumberInputWithUnit
          inputWidth="5em"
          margin="0 0 0 0"
          value={inputVal2}
          setValue={setInputVal2}
          onBlur={() => {}}
          direction={direction2}
        >
          {symbol2}
        </NumberInputWithUnit>

        <IncrementButton
          disabled={false}
          buttonWidth="18px"
          borderRadius="50%"
          width={10}
          stroke={2}
          color={buttonColor}
          backgroundColor={valueList.length === 0 ? colors.red : buttonBgColor}
          paddingPercent={20}
          handleClick={addToList}
        />
      </div>
      <p
        className={style.note}
        style={{ color: valueList.length === 0 ? colors.red : colors.blue }}
      >
        Click <strong>+</strong> to add a value pair.
      </p>
    </div>
  );
}

DualValueListInput.propTypes = {
  buttonBgColor: PropTypes.any,
  buttonColor: PropTypes.any,
  currentValues1: PropTypes.array,
  currentValues2: PropTypes.array,
  direction1: PropTypes.string,
  direction2: PropTypes.string,
  onAddDelete: PropTypes.func,
  symbol1: PropTypes.any,
  symbol2: PropTypes.any,
  type1: PropTypes.string,
  type2: PropTypes.string,
};

export default DualValueListInput;
